import React, { memo }  from 'react';
import IconWrapper from './IconWrapper';

const IconAngleRight = (props) => (
    <IconWrapper fill={props.fill ? props.fill : "currentColor"} className={`angle-right ${props.className}`} viewBox="0 0 8.6 14.4">
        <path d="M8.6 7.2L1.4 0 0 1.4l5.8 5.8L0 13l1.4 1.4 7.2-7.2" />
    </IconWrapper>
);

export default memo(IconAngleRight);
